import { useMutation } from '@tanstack/react-query';

import type { CheckoutSession } from 'models';

import type { CreateSessionParams } from 'services/sessions/sessions';
import { sessions } from 'services/sessions/sessions';

type Params = {
  onSuccess: (session: CheckoutSession) => void;
  onMutate?: () => void;
  onError?: (error?: unknown) => void;
  onSettled?: () => void;
};

const useCreateCheckoutSessions = (options: Params) => {
  const { mutate: createCheckoutSession } = useMutation(
    [`checkoutCreateSession`],
    async (params: CreateSessionParams) => sessions.create(params),
    options,
  );

  return {
    createCheckoutSession,
  };
};

export { useCreateCheckoutSessions };
